export const SET_CHANGE_PASSWORD_IS_VISIBLE = 'SET_CHANGE_PASSWORD_IS_VISIBLE';

export const POST_CHANGE_PASSWORD_REQUEST = 'POST_CHANGE_PASSWORD_REQUEST';
export const POST_CHANGE_PASSWORD_SUCCESS = 'POST_CHANGE_PASSWORD_SUCCESS';
export const POST_CHANGE_PASSWORD_FAILURE = 'POST_CHANGE_PASSWORD_FAILURE';
